import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import styles from './Spinner.scss';

const Spinner = (props) => {
	let classNames = styles.text
	if(props.theme === 'light'){
		classNames = classNames + ' ' + styles.isLight
	}
  return (
	<div className={styles.wrapper}>
    	<div className={styles.ldsRing}><div></div><div></div><div></div><div></div></div>
    	<div className={classNames}>{props.translate('global.loading') !== '-' ? props.translate('global.loading') : 'Please wait'}</div>
    </div>
  )
}

const mapStateToProps = state => {
    return {
        translate: getTranslate(state.locale)
    };
};
export default connect(mapStateToProps)(Spinner);



// WEBPACK FOOTER //
// ./src/components/atoms/Spinner/index.js